import { render } from "./MediaChat.vue?vue&type=template&id=f8d1f33c"
import script from "./MediaChat.vue?vue&type=script&lang=js"
export * from "./MediaChat.vue?vue&type=script&lang=js"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__